// style checkboxes
// (css needed too)
const checkbox = () => {
  const checkboxes = document.querySelectorAll(
    'label > input[type="checkbox"]'
  );

  [...checkboxes].forEach((input) => {
    // make sure checkboxes arent already styled
    if (!input.classList.contains("v-form__check-loaded")) {
      // create element
      const styledCheckbox = document.createElement("span");
      // add class for custom checkbox styles
      styledCheckbox.classList.add("v-form__checkbox");
      // insert newly created element
      input.insertAdjacentElement("afterend", styledCheckbox);
      // add class to input
      input.classList.add("v-form__check-loaded");
    }
  });
};

export default checkbox;
